import React from 'react'
import mobileHeaderBanner from "../../../assets/mobileHeadBanner.png"

import "./heroSection.css"

const HeroSection = () => {
  return (
    <div className='mobileHeroSection-container' >
        <img src={mobileHeaderBanner} className='mobileHeaderBanner'/>
    </div>
  )
}

export default HeroSection